import React from "react";
import styles from "../constants/styles";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

const LearningPlanAvailable = ({ name, value, showIcon }) => {
  const classes = styles();
  return (
    <div className={classes.attributeItem}>
      {!!showIcon && (value ? <CheckIcon /> : <CloseIcon />)}
      <Typography>{name}</Typography>
    </div>
  );
};

export default LearningPlanAvailable;
